export const engagmentModelPageDataArabic = {
  understandEngageModal: {
    heading: "فهم نماذج التعاقد",
    paragraphOne:
      "العثور على الطريقة المناسبة للتعاون يمكن أن يصنع فارقًا كبيرًا في نجاح المشروع. تم تصميم نماذج التعاقد لدينا لتمنح الشركات المرونة في توظيف المواهب التقنية التي تتوافق مع احتياجاتها الدقيقة. سواء كنت بحاجة إلى فرق مخصصة، أو مطورين عن بُعد، أو نهج توظيف قائم على العقود، نضمن لك عملية سلسة تحقق النتائج.",
    paragraphTwo:
      "اختيار أفضل استراتيجية للاستعانة بمصادر خارجية في مجال تكنولوجيا المعلومات أمر أساسي لكفاءة المشروع والنمو على المدى الطويل. توفر نماذجنا حلول توظيف قابلة للتوسع، موثوقة، وفعّالة من حيث التكلفة، مما يضمن تنفيذًا سلسًا، وتكاليف محسّنة، ونتائج عالية الجودة.",
    greenHeading: "مزايا نماذج التعاقد مع Bitsclan:",
    objectiveList: [
      { id: 1, description: "مرونة في توسيع فريق التطوير حسب نمو عملك." },
      {
        id: 2,
        description: "الوصول إلى فريق متخصص مكرّس لتحقيق أهداف مشروعك.",
      },
      {
        id: 3,
        description: "عمليات محسّنة تُبسط سير العمل وتقلل التكاليف التشغيلية.",
      },
      {
        id: 4,
        description: "زيادة كفاءة المشروع مما يؤدي إلى تسليم أسرع ونتائج أفضل.",
      },
      {
        id: 5,
        description: "التأقلم مع تغيّر متطلبات العمل من خلال نماذج مرنة.",
      },
      {
        id: 6,
        description: "تكاليف تطوير متوقعة مع الحفاظ على معايير الجودة.",
      },
      {
        id: 7,
        description: "شراكات طويلة الأجل تدعم الابتكار والنمو المستمر.",
      },
    ],
  },
  engagementModalScroller: {
    heading: "نماذج تعاقد مرنة لتنفيذ المشاريع بسلاسة",
    paragraphOne:
      "ندرك أن لكل مشروع احتياجاته الفريدة، ولذلك نقدم نماذج تعاقد تتناسب تمامًا مع تلك الاحتياجات. سواء كنت بحاجة إلى فرق مخصصة بالكامل أو نهج توظيف أكثر مرونة، نضمن لك عملية تطوير فعّالة، قابلة للتنبؤ، ومبنية على النتائج.",
    paragraphTwo: "اختر الأنسب، ودعنا نحقق النجاح لمشروعك بسلاسة.",
    subHeading: "اختيار النموذج المناسب للتعاون والنمو",
    paragraphThree:
      "العثور على نموذج التعاقد المناسب لا يتعلق بالتوظيف فقط، بل بضمان المرونة والكفاءة والنجاح المستدام. تمنحك نماذجنا حرية التوسع والإدارة والتحسين بما يتماشى مع أهدافك.",
    iNeedThisButton: "أحتاج هذا",
    benefits: "الفوائد",
    scrollerData: [
      {
        title: "نموذج السعر الثابت",
        description:
          "مع نموذج السعر الثابت، تحصل على تكلفة محددة مسبقًا لمشروعك بالكامل، مما يعني عدم وجود مفاجآت في الميزانية ونهج منظم لتنفيذ المشروع. مثالي للشركات الناشئة التي تحتاج إلى تخطيط دقيق وواضح.",
        benefits: [
          "اتفاقات تعاقدية واضحة بدون تكاليف خفية.",
          "إدارة وتخطيط ميزانية قابلة للتنبؤ.",
          "نطاق وأهداف مشروع محددة بوضوح.",
          "تقليل المخاطر والشكوك المالية.",
          "الأنسب للمشاريع الصغيرة والشركات الناشئة.",
        ],
        modelTitle: "اختر نموذج السعر الثابت إذا:",
        modelPoints: [
          "كانت لديك متطلبات واضحة.",
          "تُفضل وضوح الميزانية وتكلفة ثابتة.",
          "كان نطاق مشروعك مستقرًا ومحددًا جيدًا.",
          "كانت إدارة المخاطر والتحكم في التكاليف من أولوياتك.",
        ],
        userImage: "engagement-model1.png",
      },
      {
        title: "الفوترة حسب الإنجاز",
        description:
          "يمنحك هذا النموذج تحكمًا كاملاً في المدفوعات، حيث تدفع فقط عند إكمال العمل. مثالي للشركات التي ترغب في المرونة ومراقبة التكاليف.",
        benefits: [
          "المدفوعات مرتبطة بإنجاز مراحل محددة.",
          "تتبع شفاف للتكاليف للالتزام بالميزانية.",
          "زيادة المرونة مع تطور المشروع.",
          "تقليل المخاطر عبر تقسيم المشروع لمراحل.",
          "مثالي للمشاريع متوسطة إلى طويلة المدى.",
        ],
        modelTitle: "اختر الفوترة حسب الإنجاز إذا:",
        modelPoints: [
          "كنت تُفضل الدفع على مراحل.",
          "كنت بحاجة لمرونة في تنفيذ المشروع.",
          "كان نطاق المشروع عرضة للتغير.",
          "كنت بحاجة لتقدم قابل للقياس في كل خطوة.",
        ],
        userImage: "engagement-model2.png",
      },
      {
        title: "تعزيز الفريق",
        description:
          "وسّع فريقك بمطورين عن بُعد ذوي خبرة يعملون كامتداد لفريقك الداخلي. لا متاعب توظيف ولا التزامات طويلة—فقط مواهب حسب الحاجة!",
        benefits: [
          "الوصول إلى أفضل المواهب التقنية بدون تأخير في التوظيف.",
          "توسيع الفريق بسرعة حسب متطلبات المشروع.",
          "لا التزامات توظيف طويلة الأجل—ادفع لما تحتاجه فقط.",
          "تعاون سلس مع فريقك الحالي.",
          "مثالي للشركات التي تحتاج لمهارات متخصصة بسرعة.",
        ],
        modelTitle: "اختر تعزيز الفريق إذا:",
        modelPoints: [
          "كنت بحاجة إلى مواهب متخصصة فورًا.",
          "كان مشروعك يتطلب خبرة مؤقتة.",
          "كنت تُفضل تجنّب تكاليف التوظيف طويلة الأجل.",
          "كنت بحاجة لمطورين يندمجون بسهولة مع فريقك.",
        ],
        userImage: "engagement-model3.png",
      },
      {
        title: "شراكة العلامة البيضاء",
        description:
          "نقوم ببناء وإدارة الحلول التقنية بينما تنسبها لنفسك. مثالي للوكالات التي ترغب في تقديم خدمات بدون فريق داخلي.",
        benefits: [
          "دمج سلس تحت علامتك التجارية.",
          "فعّالية من حيث التكلفة—لا حاجة لفريق تطوير داخلي.",
          "توسيع عروض الخدمات بسهولة.",
          "تنفيذ المشاريع بسرية وأمان.",
          "مثالي للوكالات وشركات الاستشارات.",
        ],
        modelTitle: "اختر شراكة العلامة البيضاء إذا:",
        modelPoints: [
          "كنت ترغب في تقديم خدمات جديدة بدون توظيف.",
          "كنت بحاجة إلى شريك تطوير موثوق.",
          "كنت تُفضل فريقًا خبيرًا خلف الكواليس.",
          "كنت بحاجة لطريقة فعالة من حيث التكلفة للتوسع.",
        ],
        userImage: "engagment-scroll-image4.png",
      },
      {
        title: "البناء-التشغيل-النقل",
        description:
          "نقوم بكل شيء من بناء وتشغيل الحل التقني إلى نقله إليك عند الاستعداد. أفضل نموذج للنمو طويل الأمد.",
        benefits: [
          "تطوير وإدارة ونقل شامل للمشروع.",
          "تقليل المخاطر وتحسين التنفيذ.",
          "تركيز الأعمال على التوسع بينما نُدير التقنية.",
          "مثالي للمراكز التطويرية الخارجية والمشاريع الكبيرة.",
          "انتقال سلس بدون توقف في العمليات.",
        ],
        modelTitle: "اختر نموذج إذا:",
        modelPoints: [
          "كنت بحاجة إلى فريق خبير للإنشاء والإدارة.",
          "كنت تُفضل تقليل المخاطر التشغيلية المبكرة.",
          "كنت تُفضل نقل الملكية بطريقة منظمة.",
          "كان عملك يتوسع ويحتاج لشريك تقني.",
        ],
        userImage: "engagement-model7.png",
      },
      {
        title: "الفريق المخصص",
        description:
          "احصل على فريق مخصص بدوام كامل يعمل حصريًا على مشروعك. لا تشتيت، ولا موارد مشتركة—فقط فريق ملتزم بالكامل.",
        benefits: [
          "فريق مختار بعناية يتماشى مع رؤيتك.",
          "تعاون طويل الأمد بشفافية كاملة.",
          "موارد قابلة للتوسع حسب نمو العمل.",
          "تواصل ودمج سلسان.",
          "الأفضل للمشاريع الكبيرة التي تتطلب تطويرًا مستمرًا.",
        ],
        modelTitle: "اختر الفريق المخصص إذا:",
        modelPoints: [
          "كنت بحاجة إلى فريق بدوام كامل وعلى المدى الطويل.",
          "كنت تُريد التحكم الكامل في فريق التطوير.",
          "كان مشروعك يتطلب دعمًا وتوسعًا مستمرًا.",
          "كنت تُفضل تعاونًا ثابتًا مع فريق موثوق.",
        ],
        userImage: "engagement-model6.png",
      },
    ],
  },
};

export const EngagementModelPageBannerDataAr = {
  mainHeading: "نماذج التعاون في تطوير البرمجيات",
  greenHeading: "نهجنا في عملية التعاون.",
  content:
    "تقدم بيتسكلان مجموعة من نماذج التعاون المختلفة لتوفير الطريقة الأكثر ملاءمة للعمل على مشروعك. يمكنك اختيار نموذج من النماذج المذكورة أدناه أو اقتراح نموذج خاص بك.",
  btnText: "ابدأ الآن",
  bannerList: [
    { list: "المتعاقدون المستقلون" },
    { list: "وظائف بدوام كامل" },
    { list: "فرق عالمية" },
  ],
};
